export default "<embed src=\"assets/CGUV2.pdf\" width=\"100%\" height=\"900\" alt=\"pdf\">\n"